import { Inject, Injectable } from '@angular/core';
import { CrmDependencies, CrmInjectionToken } from '../tokens-and-interfaces';
import { ScoringApiService } from '@vendasta/crm';
import { Observable, shareReplay } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

@Injectable()
export class ScoreService {
  constructor(
    @Inject(CrmInjectionToken) private readonly config: CrmDependencies,
    private scoringApiService: ScoringApiService,
  ) {}

  private crmObjectId = '';
  setObjectId(objectId: string): void {
    this.crmObjectId = objectId;
  }

  getScoreForProfile$(fieldId: string): Observable<number | null> {
    return this.getScore$(this.crmObjectId, fieldId);
  }

  getScoreForTableRow$(companyId: string, fieldId: string): Observable<number | null> {
    return this.getScore$(companyId, fieldId);
  }

  private getScore$(companyId: string, fieldId: string): Observable<number | null> {
    return this.config.namespace$.pipe(
      switchMap((namespace) => {
        return this.scoringApiService.getScore({
          namespace: namespace,
          scoringIdentifier: {
            crmObjectId: companyId,
            crmObjectType: 'Company',
            label: fieldId,
          },
        });
      }),
      map((response) => response?.score ?? null),
      shareReplay(1),
    );
  }
}
